// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2_1kC","disabled":"FileBtn_disabled__3J8OK","warn":"FileBtn_warn__3HewZ","fade":"FileBtn_fade__1sWyU"};